export enum PickUpEnum {
  ASAP = 'ASAP',
  Scheduled = 'Scheduled',
  Immediate = 'Immediate',
}
